import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MegamenuComponent } from '../megamenu/megamenu.component';
import { FooterComponent } from '../footer/footer.component';
import { ServiceOfferingsComponent } from '../service-offerings/service-offerings.component';

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrl: './landing-page.component.css',
  imports: [
    MatButtonModule,
    MatToolbarModule,
    MatIconModule,
    MegamenuComponent,
    FooterComponent,
    ServiceOfferingsComponent
  ]
})
export class LandingPageComponent {
  
  constructor(private router: Router) {}

  navigateToContact() {
    this.router.navigate(['/contact']);
  }
}